import type { HeaderNavLink } from './header';

export const headerData: HeaderNavLink[] = [
  {
    linkUrl: '#',
    linkLabel: 'Pre-License',
    isDropDown: true,
    menuSize: '340px',
    ddList: [
      {
        linkUrl: '/pre-license/',
        linkLabel: '<strong>All</strong> Pre-License Courses',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/national/',
        linkLabel: '<strong>National</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/arizona/',
        linkLabel: '<strong>Arizona</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/california/',
        linkLabel: '<strong>California</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/colorado/',
        linkLabel: '<strong>Colorado</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/florida/',
        linkLabel: '<strong>Florida</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/indiana/',
        linkLabel: '<strong>Indiana</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/new-york/',
        linkLabel: '<strong>New York</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/north-carolina/',
        linkLabel: '<strong>North Carolina</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/pennsylvania/',
        linkLabel: '<strong>Pennsylvania</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/tennessee/',
        linkLabel: '<strong>Tennessee</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/texas/',
        linkLabel: '<strong>Texas</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/washington/',
        linkLabel: '<strong>Washington</strong> Mortgage License',
        newTab: false,
        nofollow: false,
      },
    ],
  },
  {
    linkUrl: '/continuing-education/',
    linkLabel: 'Continuing Education',
    menuSize: '340px',
    isDropDown: false,
  },
  {
    linkUrl: '/about-us/',
    linkLabel: 'About Us',
    menuSize: '340px',
    isDropDown: false,
  },
  {
    linkUrl: '#',
    linkLabel: 'Resources',
    menuSize: '340px',
    isDropDown: true,
    ddList: [
      {
        linkUrl: '/resources/',
        linkLabel: '<strong>Blog</strong>',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/question-of-the-day/',
        linkLabel: '<strong>Question of the Day</strong>',
        newTab: false,
        nofollow: false,
      },
    ],
  },
];

export const myAccountData: HeaderNavLink[] = [
  {
    linkUrl: '#',
    linkLabel: 'My Account',
    menuSize: '180px',
    isDropDown: true,
    ddList: [
      {
        linkUrl: 'https://app.aceable.com/user/signin',
        linkLabel: 'Sign In',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/support/',
        linkLabel: 'Help Center',
        newTab: false,
        nofollow: false,
      },
    ],
  },
];
